import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=72c6456e&scoped=true&"
import script from "./CartButton.vue?vue&type=script&lang=ts&"
export * from "./CartButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c6456e",
  null
  
)

export default component.exports